export class UpdateMediaRequest {
  mediaId: string;
  mediaType: MediaType;
  fields: {};

  constructor(
    mediaId: string,
    mediaType: MediaType,
    fields: Map<string, string>,
  ) {
    this.mediaId = mediaId;
    this.mediaType = mediaType;
    this.fields = this.convertToJson(fields);
  }

  // Convert Map to JSON object so backend can accept it
  convertToJson(toUpdate: Map<string, string>): {} {
    // Only update the columns that are editable for the given type
    const contactCols = [
      "section_id",
      "display_order",
      "media_url",
      "media_name",
      "media_title",
      "media_email",
    ];
    const linkCols = [
      "section_id",
      "display_order",
      "media_url",
      "display_text",
      "media_description",
    ];
    const htmlTextCols = [
      "section_id",
      "display_order",
      "media_url",
      "media_description",
    ];

    let editableCols = [];
    switch (this.mediaType) {
      case "link":
        editableCols = linkCols;
        break;
      case "contact":
        editableCols = contactCols;
        break;
      case "htmlText":
        editableCols = htmlTextCols;
        break;
      default:
        break;
    }

    // Filter out invalid columns
    const validCols: Map<string, string> = new Map<string, string>();
    toUpdate.forEach((value: string, key: string) => {
      if (editableCols.includes(key)) {
        validCols.set(key, value);
      }
    });

    // Map valid columns to a JSON object
    return Array.from(validCols.entries()).reduce(
      (main, [key, value]) => ({ ...main, [key]: value }),
      {},
    );
  }
}

export enum MediaType {
  link = "link",
  contact = "contact",
  htmlText = "htmlText",
}

export enum MediaUpdateField {
  // Editable properties for all media types:
  sectionId = "section_id",
  displayOrder = "display_order",
  mediaUrl = "media_url",

  mediaDescription = "media_description", // For Link and HtmlText only
  displayText = "display_text", // For Link only
  mediaName = "media_name", // For Contact only
  mediaTitle = "media_title", // For Contact only
  mediaEmail = "media_email", // For Contact Only
}
